export default __webpack_public_path__ + "static/media/not-found.5eb3e644.svg";